import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=f218352a&"
import script from "./FormContainer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FormContainer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports